export default class ChatConversationCreateRequest{

    static toJson(userId, customType, message, context){
        return {
            'user-id': userId,
            'custom-type': customType,
            'message': message,
            'context': context
        }
    }
}